const BASE = '/wowsmart/v4';

export const WS = {
  base: BASE,
  nav: {
    home: `${BASE}/navbar-ico/home.png`,
    missions: `${BASE}/navbar-ico/missions.png`,
    levels: `${BASE}/navbar-ico/levels.png`,
    board: `${BASE}/navbar-ico/leaderboard.png`,
    store: `${BASE}/navbar-ico/store.png`,
    inbox: `${BASE}/navbar-ico/activity-log.png`,
    badges: `${BASE}/navbar-ico/badges.png`,
    arrow: `${BASE}/navbar-ico/navbar-arrow.png`,
    /** outline fallback icon (not a frame) */
    avatarOutline: `${BASE}/navbar-ico/navbar-avatar.png`,
    /** pencil edit affordance next to nickname */
    nickEdit: `${BASE}/navbar-ico/navbar-name.png`,
  },
  home: {
    points: `${BASE}/home-points.png`,
    pointsTotal: `${BASE}/home-points-total.png`,
    gems: `${BASE}/home-gems.png`,
    diamonds: `${BASE}/home-diamonds.png`,
    levels: `${BASE}/home-levels.png`,
    missions: `${BASE}/home-missions.png`,
    badges: `${BASE}/home-badges.png`,
    minigames: `${BASE}/home-minigames.png`,
  },
  chrome: {
    close: `${BASE}/close.png`,
    closeFocus: `${BASE}/close-focus.png`,
    backMob: `${BASE}/back-button-mob.png`,
    /** default cartoon avatar */
    user: `${BASE}/user-icon.png`,
    headerScore: `${BASE}/header-score.png`,
    headerMob: `${BASE}/header-mob.png`,
    navbarMob: `${BASE}/navbar-mob.png`,
    contentBg: `${BASE}/content-bg.png`,
    contentBgMob: `${BASE}/content-bg-mob.png`,
    border: `${BASE}/widget-border.png`,
    standaloneBorder: `${BASE}/standalone-widget-border.png`,
    standaloneBg: `${BASE}/standalone-content-bg.png`,
    navBg: `${BASE}/nav-button-bg.png`,
    navBgActive: `${BASE}/nav-button-bg-active.png`,
    arrowLeft: `${BASE}/arrow-left.png`,
    arrowRight: `${BASE}/arrow-right.png`,
    check: `${BASE}/check.png`,
    dashArrow: `${BASE}/dash-arrow.png`,
    dashArrowOrange: `${BASE}/dash-arrow-orange.png`,
  },
  boxes: {
    /** 160×181 mission/store art frame */
    content: `${BASE}/content-box.png`,
    /** 338×180 desktop mission/activity card */
    card: `${BASE}/content-box-card.png`,
    /** 407×157 store item card */
    store: `${BASE}/content-box-store.png`,
    storeHome: `${BASE}/content-box-home-store.png`,
    /** 181×240 portrait mission card */
    tall: `${BASE}/content-box-tall.png`,
    /** 338×180 mobile mission card (same layout family) */
    mission: `${BASE}/mission-box-mob.png`,
    /** 251×275 level / big card */
    big: `${BASE}/big-card-box.png`,
    /** 413×122 wide bonus banner — section header, not product thumb */
    bonus: `${BASE}/bonus-box.png`,
    jackpot: `${BASE}/jackpot-box.png`,
    tournament: `${BASE}/tournament-box.png`,
    minigame: `${BASE}/minigame-box.png`,
    giftFeatured: `${BASE}/giftbox-featured.png`,
  },
  progress: `${BASE}/progress-bar.png`,
  progressFill: `${BASE}/progress-bar-fill.png`,
  lb: {
    1: `${BASE}/leaderboard-first-place.png`,
    2: `${BASE}/leaderboard-second-place.png`,
    3: `${BASE}/leaderboard-third-place.png`,
    other: `${BASE}/leaderboard-other-place.png`,
    me: `${BASE}/leaderboard-my-user.png`,
    podium: `${BASE}/tournament-podium.png`,
  },
  empty: {
    default: `${BASE}/empty.png`,
    missions: `${BASE}/empty-missions.png`,
    store: `${BASE}/empty-store.png`,
    activity: `${BASE}/empty-activity-log.png`,
    badges: `${BASE}/empty-badges.png`,
    wheel: `${BASE}/empty-wheel.png`,
  },
  labels: {
    hot: `${BASE}/label-hot.png`,
    new: `${BASE}/label-new.png`,
    sale: `${BASE}/label-sale.png`,
    vip: `${BASE}/label-vip.png`,
  },
  ribbons: {
    10: `${BASE}/ribbon-10.png`,
    15: `${BASE}/ribbon-15.png`,
    20: `${BASE}/ribbon-20.png`,
    25: `${BASE}/ribbon-25.png`,
    50: `${BASE}/ribbon-50.png`,
  },
  inbox: {
    header: `${BASE}/inbox-header.png`,
    close: `${BASE}/inbox/close-btn.png`,
    favor: `${BASE}/inbox/inbox-favor.png`,
    favorOn: `${BASE}/inbox/inbox-favor-active.png`,
    allRead: `${BASE}/inbox/inbox-allread.png`,
    markAll: `${BASE}/inbox/mark-all-read.png`,
    personal: `${BASE}/inbox/personal-message.png`,
    delete: `${BASE}/inbox/delete-btn.png`,
  },
  storeSearch: `${BASE}/store-search-input.png`,
  storeTimer: `${BASE}/store-timer.png`,
  pointsHistoryHeader: `${BASE}/points-history-header.png`,
  popup: {
    tl: `${BASE}/popup_bg_top_left.png`,
    t: `${BASE}/popup_bg_top.png`,
    tr: `${BASE}/popup_bg_top_right.png`,
    l: `${BASE}/popup_bg_left.png`,
    c: `${BASE}/popup_bg_center.png`,
    r: `${BASE}/popup_bg_right.png`,
    bl: `${BASE}/popup_bg_bottom_left.png`,
    b: `${BASE}/popup_bg_bottom.png`,
    br: `${BASE}/popup_bg_bottom_right.png`,
  },
};
